var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBlueprint = function SvgBlueprint(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 540 360"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 540,
    height: 360,
    fill: "#FCF7F7",
    rx: 20
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#192150",
    d: "M255.044 330.629c-1.177 0-2.295-.235-3.159-.745l-71.009-40.989c-.923-.53-1.413-1.295-1.413-2.139 0-.981.687-1.943 1.903-2.629l70.048-40.44c2.139-1.236 5.298-1.354 7.162-.275l71.01 40.989c.922.53 1.413 1.295 1.413 2.139 0 .981-.687 1.943-1.904 2.629l-70.048 40.44c-1.158.687-2.61 1.02-4.003 1.02m-2.609-1.687c1.511.883 4.297.746 6.063-.275l70.048-40.439c.844-.491 1.354-1.119 1.354-1.688s-.471-.961-.863-1.177l-71.01-40.989c-1.511-.883-4.297-.746-6.063.275l-70.048 40.439c-.844.491-1.354 1.119-1.354 1.688s.471.961.863 1.177z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#blueprint_svg__a)",
    d: "M331 263.699v8.779l-76 43.886-76-43.886v-8.779z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#blueprint_svg__b)",
    d: "M331 263.699v8.779l-76 43.886-76-43.886v-8.779z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#blueprint_svg__c)",
    d: "m255 307.576-76-43.877 76-43.876 76 43.876z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m255 306.55-75.106-43.368-.894.517 76 43.877 76-43.877-.894-.508z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#0F054C",
    d: "m255.003 297.46-58.451-33.751 58.451-33.742 58.452 33.742z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#blueprint_svg__d)",
    d: "m255 297.46-58.451-33.751L255 229.967l58.452 33.742z",
    opacity: 0.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#blueprint_svg__e)",
    d: "m255.001 221.451 58.451 33.751v8.506l-58.451-33.751z",
    opacity: 0.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#blueprint_svg__f)",
    d: "m255 229.957-58.451 33.751v-8.506L255 221.451z",
    opacity: 0.5
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#blueprint_svg__g)",
    d: "m255 288.945-58.451-33.743L255 221.451l58.452 33.751z",
    opacity: 0.5
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#blueprint_svg__h)",
    d: "M255.001 288.944v8.516l58.451-33.752v-8.506z",
    opacity: 0.5
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#blueprint_svg__i)",
    d: "M196.549 255.203v8.506L255 297.46v-8.515z",
    opacity: 0.5
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#878AA3",
    d: "m255.003 288.023-57.651-33.291-.8.47 58.451 33.743 58.452-33.743-.8-.47z",
    opacity: 0.8
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#blueprint_svg__j)",
    d: "M292.219 254.558c0 10.339-16.847 18.734-37.609 18.734-20.763 0-37.61-8.395-37.61-18.734s16.847-18.735 37.61-18.735 37.609 8.396 37.609 18.735",
    filter: "url(#blueprint_svg__k)",
    opacity: 0.8
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#B2B2C6",
    d: "M236.447 248.694c1.043-3.352 3.663-5.522 5.888-4.845 2.198.676 2.479 3.775 2.113 7.324-.084.648-.451 1.212-.76 1.747a7.3 7.3 0 0 0-.902 3.69c0 .987-.141 2.057-.479 3.128-.704 2.282-2.986 3.803-4.677 4.648a2.786 2.786 0 0 1-3.775-1.352c-.929-2.001-1.408-4.987-.084-7.381.535-.986 2.479-6.339 2.676-6.959m22.933-5.268c.535.395 1.324 1.296 1.859 1.888 1.296 1.38 3.127 2.169 4.987 2.817 2.563.902 4.62 1.099 6.113.704 1.437-.366 2.028-2.056 1.183-3.268-.817-1.183-2.338-2.732-4.338-4.507a197 197 0 0 0-3.099-2.677c-1.212-1.042-2-2.507-2.141-4.113-.085-.873-.198-1.662-.338-1.718-3.128-1.183-7.579-.535-8.367.986 0 0-.874 4.648-.874 5.803 0 .733.226 1.944 1.578 2.451.817.366 2.169.733 3.437 1.634"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#464878",
    d: "M232.897 124.314v11.241c0 1.69 2.846 110.068 2.846 110.068 0 2.789 10.508 3.043 10.48-.563l5.522-78.91 2.169 66.965c-.028 3.381 11.663 2.564 11.466-.254l1.634-89.728a20.6 20.6 0 0 0-.451-4.733z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#12154C",
    d: "m251.743 166.545 2.254-1.381c1.268-.76 2.845.198 2.789 1.663l-3.015 59.978z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#343C6B",
    d: "M288.621 125.132s.676 1.295.31 4.789c-.254 2.451-1.606 4.282-1.606 4.282l-2.508-1.859 1.606-6.621z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#9BA1A7",
    d: "M290.762 126.118s.536 1.042.254 3.831c-.197 1.944-1.296 3.409-1.296 3.409l-2-1.493 1.267-5.296z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#F3D4D7",
    d: "M303.918 131.217c-.648.564-5.634 2.282-7.156 2.226-3.07-.141-8.648-.62-9.409-.761-.592-.084-1.24-.197-1.944-.282l1.55-6.761c.788.254 1.549.535 2.366.817.592.197.93.254 1.268.31.056 0 .817-1.549.817-1.549.31-.62.817-1.127 1.465-1.465 0 0 1.718-.874 2.901-1.353 1.437-.619 2.536-1.296 2.987-.704.507.648-.648 1.578-1.127 1.916l-2.479 1.887c2.958-1.408 6-3.127 6.395-1.127-.057 0 6.169 3.437 2.366 6.846"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#C6D0E9",
    d: "M289.721 133.386c-.085 0-1.662.113-3.888.057l1.38-7.973c2.029.366 3.55.676 3.55.676-1.718.733-1.803 5.944-1.042 7.24"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#12154C",
    d: "M288.62 125.132c-2.113.93-2.225 7.494-1.295 9.071 0 0-21.27.029-24.82-2.986-2.451-2.085-6.057-22.904-7.494-31.722a2.83 2.83 0 0 1 .395-2.197 3 3 0 0 1 1.943-1.352s9.438-1.212 9.72.253c.704 3.69 4.226 21.186 4.874 25.017.056.366.338.564.704.704 1.493.536 15.973 3.212 15.973 3.212"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#D3D3E7",
    d: "m227.349 105.552 4.31 14.312.845 26.143c1.493 9.692 33.666 6.818 33.666-5.775V96.284c0-7.494-5.381-10.847-10.903-10.255a12.4 12.4 0 0 0-3.549.902c-.451.169-3.804-1.662-4.254-1.437l-8.959 5.183c-.62.367-1.212.705-1.775 1.043-5.86 3.55-9.381 6.902-9.381 13.832"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#F3D4D7",
    d: "M241.801 77.86v12.423c.056.536.366 1.07 1.014 1.493 1.662 1.07 4.733 1.268 6.959.48 1.295-.48 1.972-1.184 1.972-1.945V80.34l-4.705-6.086h-.507zm-2.734 100.038c-.564.197-1.324-.535-1.55-1.296-.225-.704-1.239-2.535-1.239-2.535s-1.409 3.803-3.268 3.042c-4.733-1.972-4.733-4.423-4.367-6.169.394-1.803 1.493-3.043 1.747-4.761l-.564-6.085h6.424l-.113 3.634a7.9 7.9 0 0 0 1.042 4.226l.676 1.155c.338.591.564 1.239.705 1.887l1.014 4.874c.31 1.042.225 1.775-.507 2.028"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#464878",
    d: "M269.886 146.148c0 4.113-6.564 8.959-7.409 8.367-.901-.619.761-25.861-1.296-42.455-1.042-8.367-2.817-16.058-5.719-20.847-1.436-2.338-3.775-4.17-3.549-4.198 1.296-.253.986-.873 1.972-1.07.141-.028 1.296 0 1.437 0 5.578 0 11.775 2.732 11.775 10.226l.846 18.396zm-37.58 8.424-.648-34.708-6.029-13.551c0-6.93 5.24-11.044 11.128-14.593a27 27 0 0 1 1.775-1.043l3.296-1.915c0 .084-.282 1.915-.282 1.915-.479 3.296 6.198 16.256 8.226 25.074 2.677 11.606 4.113 41.835 3.494 42.37-1.155.93-20.115 1.972-20.96-3.549"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#D3D3E7",
    d: "m227.825 109.834-.761 24.369c-.028.817 0 1.69.085 2.507l2.873 27.355c.451 1.606 6.395 1.156 6.621-.676l.76-26.876c-.028-.986 0-2 .113-2.986.479-4.198 2-18.227 2.282-22.087z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#464878",
    d: "M240.785 111.581c-.282 3.944-1.916 18.65-2.282 22.087-.113.93-.141 1.888-.113 2.845l-.648 24.031c.085 2.508-8.902 2.846-9.1.648l-2.422-24.369a21 21 0 0 1-.085-2.648l-.479-27.862z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#E2BBBF",
    d: "M241.801 77.86v.59c0 4.706 3.888 8.762 8.592 8.424.423-.028.761-.084 1.099-.14a.8.8 0 0 1 .282-.057V80.31l-4.705-6.085-.197-.254-.31.254z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#F3D4D7",
    d: "M256.026 65.914c2.367 3.831 4.057 11.184 2.057 15.213-1.24 2.507-3.043 3.803-5.607 3.916-1.014.028-5.69-.535-9.015-2.733-2.169-1.437-3.944-3.211-5.071-4.986-4-6.226-2.366-12.537 2.592-15.777 9.1-5.916 11.833-.817 15.044 4.367"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#343C6B",
    d: "M231.968 70.422c.31 4.62 3.69 9.944 9.832 12.536v-2.507c-.789-.733-1.578-1.55-1.944-2.676-.226-.677.845-1.071 1.944-.649.056 0 .112.029.169.057.479.225 1.183.169 1.915.056 1.184-.197 1.832-1.465 1.353-2.535-3.268-7.663 5.747-9.438 7.973-11.973.957.93 2.845 3.211 2.845 3.211-.254-1.127-.958-2.394-1.465-3.747-1.381-3.521-5.015-5.606-8.705-5.127a12 12 0 0 0-1.86.338c-9.043 2.17-12.339 8.452-12.057 13.016"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#F3D4D7",
    d: "M243.799 76.591c1.718 1.55 2.31 3.69 1.324 4.818s-3.212.788-4.93-.761c-1.719-1.55-2.31-3.69-1.324-4.817s3.211-.79 4.93.76"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#4B4F8E",
    d: "m394.363 63.757-92.489 54.006A13.73 13.73 0 0 0 295 129.652v73.05c0 5.296 5.747 8.592 10.311 5.944l92.517-54.259a13.76 13.76 0 0 0 6.846-11.889V69.702c0-5.297-5.747-8.593-10.311-5.945"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#E2E9FB",
    d: "M397.798 65.983 305.31 119.99a13.73 13.73 0 0 0-6.874 11.889v73.05c0 5.296 5.747 8.592 10.31 5.944l92.518-54.259a13.76 13.76 0 0 0 6.845-11.889V71.927c0-5.296-5.718-8.592-10.311-5.944"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#blueprint_svg__l)",
    d: "M397.798 65.983 305.31 119.99a13.73 13.73 0 0 0-6.874 11.889v73.05c0 5.296 5.747 8.592 10.31 5.944l92.518-54.259a13.76 13.76 0 0 0 6.845-11.889V71.927c0-5.296-5.718-8.592-10.311-5.944"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#4B4F8E",
    d: "m443.133 113.397-56.907 33.214a8.47 8.47 0 0 0-4.226 7.325v44.935c0 3.268 3.522 5.296 6.339 3.662l56.907-33.384c2.592-1.521 4.198-4.31 4.198-7.296v-44.794c.028-3.24-3.493-5.296-6.311-3.662"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#E2E9FB",
    d: "m446.569 115.538-56.908 33.215a8.47 8.47 0 0 0-4.225 7.324v44.935c0 3.268 3.521 5.296 6.338 3.662l56.908-33.384a8.49 8.49 0 0 0 4.197-7.296V119.2c.029-3.24-3.493-5.296-6.31-3.662"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#blueprint_svg__m)",
    d: "m446.569 115.538-56.908 33.215a8.47 8.47 0 0 0-4.225 7.324v44.935c0 3.268 3.521 5.296 6.338 3.662l56.908-33.384a8.49 8.49 0 0 0 4.197-7.296V119.2c.029-3.24-3.493-5.296-6.31-3.662"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#4B4F8E",
    d: "m122.973 73.562 56.907 33.215a8.47 8.47 0 0 1 4.226 7.324v44.935c0 3.268-3.521 5.296-6.339 3.662l-56.907-33.384c-2.592-1.521-4.198-4.31-4.198-7.296V77.224c-.028-3.24 3.494-5.268 6.311-3.662"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#E2E9FB",
    d: "m119.311 75.703 56.908 33.215a8.47 8.47 0 0 1 4.226 7.324v44.935c0 3.268-3.522 5.296-6.339 3.662l-56.908-33.384c-2.591-1.521-4.197-4.31-4.197-7.296V79.365c-.057-3.24 3.493-5.268 6.31-3.662"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#blueprint_svg__n)",
    d: "m119.311 75.703 56.908 33.215a8.47 8.47 0 0 1 4.226 7.324v44.935c0 3.268-3.522 5.296-6.339 3.662l-56.908-33.384c-2.591-1.521-4.197-4.31-4.197-7.296V79.365c-.057-3.24 3.493-5.268 6.31-3.662"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#4B4F8E",
    d: "m131.41 202.379 36.905 21.552a5.5 5.5 0 0 1 2.733 4.761v29.13c0 2.113-2.282 3.437-4.113 2.366l-36.934-21.664a5.49 5.49 0 0 1-2.732-4.733v-29.045c.028-2.113 2.31-3.437 4.141-2.367"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#E2E9FB",
    d: "m128.113 204.21 36.906 21.552a5.5 5.5 0 0 1 2.732 4.761v29.13c0 2.113-2.282 3.437-4.113 2.366l-36.905-21.664a5.49 5.49 0 0 1-2.733-4.733v-29.045c0-2.113 2.282-3.437 4.113-2.367"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#blueprint_svg__o)",
    d: "m128.113 204.21 36.906 21.552a5.5 5.5 0 0 1 2.732 4.761v29.13c0 2.113-2.282 3.437-4.113 2.366l-36.905-21.664a5.49 5.49 0 0 1-2.733-4.733v-29.045c0-2.113 2.282-3.437 4.113-2.367"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#B8C9F5",
    d: "m426.133 169.4-56.907 33.215A8.47 8.47 0 0 0 365 209.94v44.934c0 3.268 3.522 5.297 6.339 3.663l56.907-33.384c2.592-1.521 4.198-4.31 4.198-7.297v-44.793c.028-3.268-3.493-5.297-6.311-3.663"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#blueprint_svg__p)",
    d: "m426.133 169.4-56.907 33.215A8.47 8.47 0 0 0 365 209.94v44.934c0 3.268 3.522 5.297 6.339 3.663l56.907-33.384c2.592-1.521 4.198-4.31 4.198-7.297v-44.793c.028-3.268-3.493-5.297-6.311-3.663"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#B8C9F5",
    d: "m59.17 126.378 37.356 21.806c1.718.986 2.76 2.817 2.76 4.817v29.496c0 2.141-2.31 3.465-4.169 2.395l-37.356-21.918A5.51 5.51 0 0 1 55 158.185v-29.384c0-2.169 2.31-3.493 4.17-2.423"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#blueprint_svg__q)",
    d: "m59.17 126.378 37.356 21.806c1.718.986 2.76 2.817 2.76 4.817v29.496c0 2.141-2.31 3.465-4.169 2.395l-37.356-21.918A5.51 5.51 0 0 1 55 158.185v-29.384c0-2.169 2.31-3.493 4.17-2.423"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#B8C9F5",
    d: "m95.17 203.378 37.356 21.806c1.718.986 2.761 2.817 2.761 4.817v29.496c0 2.141-2.311 3.465-4.17 2.395l-37.356-21.918A5.51 5.51 0 0 1 91 235.185v-29.384c0-2.169 2.31-3.493 4.17-2.423"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#blueprint_svg__r)",
    d: "m95.17 203.378 37.356 21.806c1.718.986 2.761 2.817 2.761 4.817v29.496c0 2.141-2.311 3.465-4.17 2.395l-37.356-21.918A5.51 5.51 0 0 1 91 235.185v-29.384c0-2.169 2.31-3.493 4.17-2.423"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#B8C9F5",
    d: "m353.117 29.378-37.356 21.806C314.042 52.17 313 54 313 56v29.497c0 2.141 2.31 3.465 4.169 2.395l37.357-21.918a5.51 5.51 0 0 0 2.76-4.79V31.802c0-2.169-2.338-3.493-4.169-2.422z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#blueprint_svg__s)",
    d: "m353.117 29.378-37.356 21.806C314.042 52.17 313 54 313 56v29.497c0 2.141 2.31 3.465 4.169 2.395l37.357-21.918a5.51 5.51 0 0 0 2.76-4.79V31.802c0-2.169-2.338-3.493-4.169-2.422z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "blueprint_svg__a",
    x1: 141.426,
    x2: 336.198,
    y1: 290.029,
    y2: 290.029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#676D92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9DA1BA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "blueprint_svg__b",
    x1: 180.587,
    x2: 194.466,
    y1: 302.621,
    y2: 244.517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E819C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969AAF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "blueprint_svg__c",
    x1: 255,
    x2: 255,
    y1: 219.823,
    y2: 307.576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9195AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BABACD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "blueprint_svg__d",
    x1: 196.545,
    x2: 313.454,
    y1: 263.709,
    y2: 263.709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "blueprint_svg__e",
    x1: 254.999,
    x2: 313.454,
    y1: 242.577,
    y2: 242.577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "blueprint_svg__f",
    x1: 196.547,
    x2: 255.002,
    y1: 242.577,
    y2: 242.577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "blueprint_svg__g",
    x1: 196.545,
    x2: 313.454,
    y1: 255.193,
    y2: 255.193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "blueprint_svg__h",
    x1: 254.999,
    x2: 313.454,
    y1: 276.328,
    y2: 276.328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "blueprint_svg__i",
    x1: 196.547,
    x2: 255.002,
    y1: 276.329,
    y2: 276.329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "blueprint_svg__l",
    x1: 353.272,
    x2: 353.272,
    y1: 65.049,
    y2: 211.806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEC1CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECECF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "blueprint_svg__m",
    x1: 419.158,
    x2: 419.158,
    y1: 114.964,
    y2: 205.251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEC1CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECECF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "blueprint_svg__n",
    x1: 146.722,
    x2: 146.722,
    y1: 75.141,
    y2: 165.416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEC1CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECECF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "blueprint_svg__o",
    x1: 145.876,
    x2: 145.876,
    y1: 203.831,
    y2: 262.399,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEC1CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECECF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "blueprint_svg__p",
    x1: 427.282,
    x2: 386.016,
    y1: 259.526,
    y2: 159.873,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4A7BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CACCD7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "blueprint_svg__q",
    x1: 95.897,
    x2: 68.814,
    y1: 185.541,
    y2: 120.119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4A7BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CACCD7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "blueprint_svg__r",
    x1: 131.897,
    x2: 104.814,
    y1: 262.541,
    y2: 197.119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4A7BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CACCD7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "blueprint_svg__s",
    x1: 353.897,
    x2: 326.814,
    y1: 88.541,
    y2: 23.119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4A7BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CACCD7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "blueprint_svg__j",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(0 18.7344 -37.6097 0 254.61 254.558)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10134A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10134A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "blueprint_svg__k",
    width: 83.22,
    height: 45.469,
    x: 213,
    y: 231.823,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_15_42384",
    stdDeviation: 2
  })))));
};
export default SvgBlueprint;